import { z } from "zod";

import { listSearchBaseShape, searchTextSchema } from "/src/router/searchSchemas";

export const userListSearchSchema = z.object({
  ...listSearchBaseShape,
  username: searchTextSchema,
});

export type UserListSearch = z.infer<typeof userListSearchSchema>;

export const userListSearchFields = ["username"] as const;

export type UserListSearchField = (typeof userListSearchFields)[number];
export type UserListSearchFormValues = Pick<UserListSearch, UserListSearchField>;

function createUserSearchValues(
  getValue: (field: UserListSearchField) => string | undefined,
): UserListSearchFormValues {
  return userListSearchFields.reduce((values, field) => {
    values[field] = getValue(field);
    return values;
  }, {} as UserListSearchFormValues);
}

export const emptyUserListSearch = createUserSearchValues(() => undefined);

export function getUserSearchValues(search: UserListSearch): UserListSearchFormValues {
  return createUserSearchValues((field) => search[field]);
}

export function getUserSearchPatch(
  values: Partial<Record<UserListSearchField, string | undefined>>,
): UserListSearchFormValues {
  return createUserSearchValues((field) => values[field] || undefined);
}
